import type { ComponentPropsWithoutRef } from "react";

export const PersonCircleIcon = ({
  className,
  ...props
}: ComponentPropsWithoutRef<"svg">) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M7.7207 20.662V19C7.7207 18.4696 7.93142 17.9609 8.30649 17.5858C8.68156 17.2107 9.19027 17 9.7207 17H15.7207C16.2511 17 16.7598 17.2107 17.1349 17.5858C17.51 17.9609 17.7207 18.4696 17.7207 19V20.662M22.7207 12C22.7207 17.5228 18.2436 22 12.7207 22C7.19786 22 2.7207 17.5228 2.7207 12C2.7207 6.47715 7.19786 2 12.7207 2C18.2436 2 22.7207 6.47715 22.7207 12ZM15.7207 10C15.7207 11.6569 14.3776 13 12.7207 13C11.0638 13 9.7207 11.6569 9.7207 10C9.7207 8.34315 11.0638 7 12.7207 7C14.3776 7 15.7207 8.34315 15.7207 10Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
